import React from 'react';
import { useDisclosure } from '@cardboard-ui/react';
import { OptionsMenu } from 'components/OptionsMenu';
import { OptionsMenuButton } from 'components/OptionsMenu/OptionsMenuButton';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import { LinkIcon } from 'components/icons';
import { t } from '@lingui/macro';

interface LinkCardMenuProps {
  onOpenSetLink: () => void;
}

export default function LinkCardMenu({ onOpenSetLink }: LinkCardMenuProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <OptionsMenu
        isOpen={isOpen}
        onClose={onClose}
        button={
          <OptionsMenuButton
            onClick={onOpen}
            size="xs"
            colorScheme="gray"
            variant="solid"
            borderRadius="full"
          />
        }
      >
        <OptionsMenuItem icon={<LinkIcon />} onClick={onOpenSetLink}>
          {t`Set Card Link`}
        </OptionsMenuItem>
      </OptionsMenu>
    </>
  );
}
